import TodoList from "./components/todoList";
import "./styles/main.css";

export default function App() {
  return (
    <div className="App">
      <TodoList />
    </div>
  );
};